export class AppState {
    nightmode: boolean = false;
}
